import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private breadcrumbsDataSource = new BehaviorSubject<any[]>([]);
  public breadcrumbsData = this.breadcrumbsDataSource.asObservable();

  /**
   * Add complatetly new breadcrumbs element in a store.
   */
  updateBreadcrumbsData(data) {
    this.breadcrumbsDataSource.next(data);
  }

  /**
   * Add new breadcrumbs element in a store but old data stay as it is.
   */
  addBreadcrumbsData(dataObj) {
    const currentValue = this.breadcrumbsDataSource.value;
    const updatedValue = [...currentValue, dataObj];
    this.breadcrumbsDataSource.next(updatedValue);
  }
}
